import React, { useState } from 'react';
import s from './collection-description.scss';
import { Box, Text, TextButton } from 'wix-style-react';
import { composer } from '../../../component-decorators/composer';
export var CollectionDescription = composer()
    .withExperiments()
    .compose(function (_a) {
    var description = _a.description, wordsLimit = _a.wordsLimit;
    var wordsCount = description === null || description === void 0 ? void 0 : description.split(' ').length;
    var descriptionExceedsLimit = wordsCount > wordsLimit;
    // tslint:disable-next-line:react-hooks-nesting
    var _b = useState(!descriptionExceedsLimit), showingAllText = _b[0], setShowingAllText = _b[1];
    var getDescription = function () {
        return showingAllText
            ? description
            : description === null || description === void 0 ? void 0 : description.split(' ').slice(0, wordsLimit).join(' ');
    };
    return (React.createElement(Box, { direction: 'vertical', dataHook: 'collection-description' },
        React.createElement(Text, { weight: 'thin', dataHook: 'collection-description-content', className: s.collectionDescription }, getDescription()),
        (description === null || description === void 0 ? void 0 : description.split(' ').length) > wordsLimit && (React.createElement(ExpansionToggle, { showingAllText: showingAllText, expansionToggle: function () { return setShowingAllText(!showingAllText); } }))));
});
var ExpansionToggle = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, showingAllText = _a.showingAllText, expansionToggle = _a.expansionToggle;
    return (React.createElement(TextButton, { size: "medium", onClick: expansionToggle, className: s.sizeFix }, showingAllText ? t('collection.readLess') : t('collection.readMore')));
});
//# sourceMappingURL=collection-description.js.map